import type { WikiBlock } from "../types";

/** Judgment Selling — 인내 (판매 제외, 역할 바닥). SSOT: trait.grit */
export const talentGritBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "warning",
    text: "인내는 상점에서 고르는 재능이 아니라, 직업이 얼마나 버티다 빠질지의 기본값입니다. 로스터에서는 작게만 보여 줍니다.",
  },
  { type: "h2", text: "플레이에서 보이고 싶은 것" },
  {
    type: "ul",
    items: [
      "탱커(인내 높음) → 맞아도 앞에서 오래 버틴다",
      "유리몸 DPS(인내 낮음) → 피가 조금만 깎여도 빨리 뒤로 간다",
      "너무 높으면 → 안 빼고 버티다 힐 전에 죽을 수 있다",
      "직감·통찰·유대처럼 상점에서 골라 올리는 축이 아니다",
    ],
  },
  { type: "h2", text: "디자인 의도" },
  {
    type: "ul",
    items: [
      "얼마나 맞아도 전선을 지킬까의 직업 성격이다",
      "장판 피하기(직감)·자리 고르기(통찰)·부관 따르기(유대)와 섞지 않는다",
      "탱커는 어느 정도 버티는 게 맞고, 너무 버티면 힐이 늦어 죽는다",
      "피가 이만큼이면 빼라는 별도 숫자로도 조절할 수 있다",
    ],
  },
  { type: "h2", text: "직업별 기본 느낌" },
  {
    type: "table",
    headers: ["직업", "기본", "읽는 법"],
    rows: [
      ["탱커", "높음", "앞에서 버틴다 — 너무 높으면 힐 전에 사망"],
      ["레인저 등", "낮음", "유리몸 — 빨리 안전 쪽으로"],
      ["힐러", "아주 낮음", "제일 먼저 안전 우선"],
    ],
  },
  {
    type: "p",
    text: "생존 후퇴 HP 임계(surviveHpThr) 식 → Wiki 「재능 계산식」.",
  },
];
